import { render, staticRenderFns } from "./px-step-by-step-dialog-navigation.vue?vue&type=template&id=3882df07&scoped=true&"
import script from "./px-step-by-step-dialog-navigation.vue?vue&type=script&lang=ts&"
export * from "./px-step-by-step-dialog-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./px-step-by-step-dialog-navigation.vue?vue&type=style&index=0&id=3882df07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3882df07",
  null
  
)

export default component.exports